export default "__VITE_ASSET__D2OazZ45__"